import React, { useState } from 'react';
import introVideo from '../assets/video/Web Intro(1).mp4';
// import { db, collection, addDoc, serverTimestamp } from '../firebase';
import { GOOGLE_SCRIPT_URL } from '../config';
import apparelImg from '../assets/images/Apparel.png';
import supplyChainImg from '../assets/images/Supply Chain.png';
import warehouseImg from '../assets/images/Warehouse.png';
import hrImage from '../assets/images/HrImage.png';
import oparationQualityImg from '../assets/images/Oparation&qulity.png';
import financeAccountingImg from '../assets/images/Finance&Accounting.png';
import merchandisingImg from '../assets/images/Merchandising.png';
import salesMarketingImg from '../assets/images/Sales & Marketing.png';
import productionPlanningImg from '../assets/images/Production Planning.png';
import businessAnalysisImg from '../assets/images/Business Analysis.png';

export default function Home({ navigate, user, onAuthClick }) {
  const departmentsData = [
    {
      id: 1,
      title: "Apparel Intelligence: Front-End & Plant Operations",
      tag: "Manufacturing",
      img: apparelImg,
      visualClass: "visual-blue",
      coverImage: true,
      desc: "Improve front-end and plant productivity with accurate reporting, smarter analysis and faster operational decisions."
    },
    {
      id: 2,
      title: "Supply Chain & Procurement Mastery",
      tag: "Supply Chain Management",
      img: supplyChainImg,
      visualClass: "visual-green",
      coverImage: true,
      desc: "Strengthen planning, sourcing and supplier performance with accurate data, faster reporting and better decisions."
    },
    {
      id: 3,
      title: "Warehouse & Inventory Intelligence",
      tag: "Logistics",
      img: warehouseImg,
      visualClass: "visual-amber",
      coverImage: true,
      desc: "Improve inventory accuracy, stock visibility and warehouse productivity through smarter tracking and reporting."
    },
    {
      id: 4,
      title: "HR People Analytics",
      tag: "Human Resources",
      img: hrImage,
      visualClass: "visual-mint",
      coverImage: true,
      desc: "Turn workforce data into clear insights to improve HR reporting, planning, productivity and people decisions."
    },
    {
      id: 5,
      title: "Operations, Quality & Continuous Improvement",
      tag: "Operational Exellence",
      img: oparationQualityImg,
      visualClass: "visual-blue",
      coverImage: true,
      desc: "Improve process efficiency, quality reporting and continuous improvement through accurate, actionable data."
    },
    {
      id: 6,
      title: "Finance & Accounting Intelligence",
      tag: "Finance",
      img: financeAccountingImg,
      visualClass: "visual-green",
      coverImage: true,
      desc: "Improve financial accuracy, reporting speed and decision-making across budgeting, costing and accounting."
    },
    {
      id: 7,
      title: "Merchandising: DIFOT Excellence",
      tag: "Merchandising",
      img: merchandisingImg,
      visualClass: "visual-amber",
      coverImage: true,
      desc: "Strengthen order tracking, delivery performance and merchandising decisions with accurate, timely reporting."
    },
    {
      id: 8,
      title: "Sales & Marketing Intelligence",
      tag: "Sales",
      img: salesMarketingImg,
      visualClass: "visual-mint",
      coverImage: true,
      desc: "Improve sales visibility, campaign reporting and profitability analysis for faster, data-driven decisions."
    },
    {
      id: 9,
      title: "Production Planning & Productivity Accelerator",
      tag: "Planning",
      img: productionPlanningImg,
      visualClass: "visual-blue",
      coverImage: true,
      desc: "Improve production planning, output tracking and productivity through accurate schedules, KPIs and analysis."
    },
    {
      id: 10,
      title: "Business Analysis & Management Reporting",
      tag: "Corporate Strategy",
      img: businessAnalysisImg,
      visualClass: "visual-green",
      coverImage: true,
      desc: "Turn business data into clear management reports, actionable insights and stronger strategic decisions."
    }
  ];

  // Video Modal state
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  // Inquiry Form state
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    organization: '',
    participants: '',
    delivery: 'Onsite',
    requirement: ''
  });
  const [formStatus, setFormStatus] = useState('');

  // FAQ Accordion state
  const [openFaq, setOpenFaq] = useState(0); // first item open by default

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('Sending…');

    // Format the email message body with all inquiry details from Home Form
    const messageBody = `
New Training Inquiry from Mr Excel Sri Lanka website (Home page Form):

• Name: ${formData.name}
• Email: ${formData.email}
• Phone: ${formData.mobile}
• Organization: ${formData.organization || 'N/A'}
• Number of Participants: ${formData.participants || 'N/A'}
• Preferred Format: ${formData.delivery}
• Brief Training Requirement:
${formData.requirement}
    `;

    const templateParams = {
      name: formData.name,
      email: formData.email,
      title: 'New Training Inquiry (Home Page)',
      message: messageBody,
    };

    try {
      // 1. Send email via Google Apps Script (Free Gmail SMTP bridge)
      if (GOOGLE_SCRIPT_URL && GOOGLE_SCRIPT_URL !== "YOUR_GOOGLE_APPS_SCRIPT_WEB_APP_URL") {
        await fetch(GOOGLE_SCRIPT_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(templateParams)
        });
      } else {
        console.warn("Google Apps Script URL is not configured. Please set GOOGLE_SCRIPT_URL in src/config.js");
      }

      // 2. Add document to "inquiries" Firestore collection in the background (does not block)
      /* 
      addDoc(collection(db, 'inquiries'), {
        name: formData.name,
        email: formData.email,
        phone: formData.mobile,
        organization: formData.organization,
        participants: formData.participants,
        format: formData.delivery,
        requirement: formData.requirement,
        source: 'Home Page Form',
        createdAt: serverTimestamp()
      }).catch((dbError) => {
        console.warn("Firestore backup save failed:", dbError);
      });
      */

      setFormStatus('Thank you. Your inquiry has been sent.');
      setFormData({
        name: '',
        email: '',
        mobile: '',
        organization: '',
        participants: '',
        delivery: 'Onsite',
        requirement: ''
      });
    } catch (error) {
      console.error("Failed to send inquiry via Google Apps Script:", error);
      setFormStatus('The message could not be sent. Please email info@mrexcelsrilanka.com.');
    }
  };

  const handleTileClick = (route) => (e) => {
    e.preventDefault();
    const isVerifiedUser = user && user.emailVerified;
    const isProtectedRoute = ['functions', 'shortcuts', 'skill-test', 'training'].includes(route);
    if (isProtectedRoute && !isVerifiedUser) {
      onAuthClick('login');
    } else {
      navigate(route);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const faqItems = [
    {
      q: "Do you conduct onsite corporate training?",
      a: "Yes. Training can be delivered onsite, online or in a hybrid format depending on your organization’s requirements."
    },
    {
      q: "Can the programme be customised for our department?",
      a: "Yes. Content, examples and exercises can be built around your department’s reports, processes, datasets and skill gaps."
    },
    {
      q: "What topics can be covered?",
      a: "Basic Excel, Advanced Excel, formulas, lookups, PivotTables, Power Query, dashboards, VBA, macros, automation and Excel + AI."
    },
    {
      q: "Can you improve an existing Excel file?",
      a: "Yes. Existing workbooks can be reviewed, corrected, redesigned or automated to improve speed, reliability and usability."
    },
    {
      q: "Can training be delivered in Sinhala?",
      a: "Yes. Training can be delivered in Sinhala, English or a practical combination of both."
    }
  ];

  return (
    <main>
      <section className="home-hero" id="training-inquiry">
        <div className="container">
          <div className="hero-intro-row">
            <div className="hero-intro-content">

              <div className="hero-brand-lockup">
                <img alt="Excel" className="hero-excel-logo" src="/assets/images/excel-logo-modern.svg" />
                <h1>
                  <span className="brand-green">Mr Excel</span> - Sri Lanka
                </h1>
              </div>
              <p className="hero-one-line lead max-960">
                Empowering organisations with practical Excel skills for smarter decisions, greater productivity and future-ready operations.
                Mr Excel Sri Lanka brings over 10 years of hands-on industry experience and a growing professional community of 73,000+.
              </p>
            </div>
          </div>
          <div className="inquiry-layout">
            <section aria-labelledby="inquiry-title" className="inquiry-panel">
              <div className="inquiry-heading">
                <div>
                  <h2 id="inquiry-title">Schedule Your Department Excel Training</h2>
                  <p>
                    Tell me about your organization, participants and expected outcomes. I will review your requirements and recommend a suitable training approach.
                  </p>
                </div>
              </div>
              <form className="form-grid compact-form" onSubmit={handleFormSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    autoComplete="name"
                    id="name"
                    name="name"
                    placeholder="Your name"
                    required
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    autoComplete="email"
                    id="email"
                    name="email"
                    placeholder="name@company.com"
                    required
                    type="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile">Mobile number</label>
                  <input
                    autoComplete="tel"
                    id="mobile"
                    name="mobile"
                    placeholder="07X XXX XXXX"
                    required
                    type="tel"
                    value={formData.mobile}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="organization">Organization Name</label>
                  <input
                    autoComplete="organization"
                    id="organization"
                    name="organization"
                    placeholder="ABC Company"
                    required
                    value={formData.organization}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="participants">No of participants</label>
                  <input
                    id="participants"
                    min="1"
                    name="participants"
                    placeholder="e.g. 20"
                    type="number"
                    value={formData.participants}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="delivery">Preferred training</label>
                  <select
                    id="delivery"
                    name="delivery"
                    value={formData.delivery}
                    onChange={handleInputChange}
                  >
                    <option value="Onsite">Onsite</option>
                    <option value="Online">Online</option>
                    <option value="Hybrid">Hybrid</option>
                    <option value="Not sure">Not sure yet</option>
                  </select>
                </div>
                <div className="form-group full">
                  <label htmlFor="requirement">Brief training requirement</label>
                  <textarea
                    id="requirement"
                    name="requirement"
                    placeholder="Departments, current Excel level, key reports, challenges and expected outcomes"
                    required
                    value={formData.requirement}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
                <div className="form-actions full">
                  <button className="btn btn-primary" type="submit">
                    Send Your Proposal
                  </button>
                  <span className="form-note">Your requirement will be reviewed before a program is recommended.</span>
                </div>
                {formStatus && (
                  <p aria-live="polite" className="form-status full" role="status">
                    {formStatus}
                  </p>
                )}
              </form>
            </section>
            <aside aria-label="Meet Pramod Fernando" className="hero-visual">
              <div className="trainer-card">
                <div className="trainer-head">
                  <span className="portrait-kicker">Corporate Trainer</span>
                  <h3>Pramod Fernando</h3>
                  <p>BSc (Hons) TM&LE, Faculty of Engineering,
                    University of Moratuwa</p>
                </div>
                <div className="trainer-image-wrap">
                  <img
                    alt="Pramod Fernando, Corporate Excel Trainer"
                    loading="eager"
                    src="/assets/images/pramod-hero-cutout.png"
                  />
                </div>
                <div aria-label="Professional credentials" className="trainer-stats">
                  <div>
                    <strong>10 Years +</strong>
                    <span>Corporate Work Experience</span>
                  </div>
                  <div>
                    <strong>1,000+</strong>
                    <span>Professionals Trained</span>
                  </div>
                  <div>
                    <strong>73,000+</strong>
                    <span>Learning Community</span>
                  </div>
                  <div>
                    <strong>Top Rated</strong>
                    <span>Global Excel Consultant</span>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <section className="home-section training-focus-section">
        <div className="container">
          <div className="section-heading section-heading-centered">
            <span className="eyebrow">Choose your path</span>
            <h2 className="one-line-heading">Excel Learning Built Around Your Business Goals</h2>
            <p className="max-960">
              Develop practical Excel capabilities across your organization through training built around real workplace challenges, reports, and measurable business outcomes.
            </p>
          </div>
          <div className="training-focus-grid">
            <article className="focus-card">
              <div className="focus-card-inner">
                <span className="focus-label">For companies and teams</span>
                <h3>Corporate Excel Training</h3>
                <p>Build practical Excel capabilities that drive smarter decisions, greater efficiency, and stronger business performance.</p>
                <ul className="clean-list focus-list">
                  <li>Practical Excel & Analytics Know-How</li>
                  <li>Logical Thinking for Smarter Problem-Solving</li>
                  <li>A Data-Driven Decision-Making Culture</li>
                  <li>Systematic Thinking for Future-Ready Operations</li>
                  <li>Greater Workplace Efficiency and Productivity</li>
                </ul>

              </div>
            </article>
            <article className="focus-video-card">
              <button
                aria-label="Watch corporate training introduction"
                className="focus-video-link"
                type="button"
                onClick={() => setVideoModalOpen(true)}
              >
                <img
                  alt="Corporate Excel training introduction video thumbnail"
                  src="/assets/images/corporate-training-video.png"
                />
                <span className="focus-video-overlay">
                  <span className="focus-play">▶</span>
                  <span className="focus-video-copy">
                    <strong>See the training approach</strong>
                    <small>Practical corporate Excel learning for real workplace needs</small>
                  </span>
                </span>
              </button>
            </article>
          </div>
        </div>
      </section>



      <section className="home-section about-section">
        <div className="container">
          <div className="about-layout">
            <div className="about-photo">
              <div className="about-photo-frame">
                <img
                  alt="Pramod Fernando, Corporate Excel Trainer and Business Analyst"
                  src="/assets/images/pramod-about-portrait.webp"
                />
              </div>
              <div className="about-quote">
                “Excel training should improve the work employees perform every day—not only their knowledge of formulas.”
              </div>
            </div>
            <div className="about-content">
              <span className="eyebrow">About me</span>
              <h2>Hi, I’m Pramod Fernando</h2>
              <p className="about-lead">
                I’m a Corporate Excel Trainer, Business Analyst and Excel Automation Specialist with more than 10 years of practical workplace experience.
              </p>
              <p>
                Through Mr Excel - Sri Lanka, I help organizations transform Excel from a basic reporting tool into a practical solution for improving productivity, automating repetitive work and supporting better business decisions.
              </p>
              <p>
                Every corporate programme is designed around real workplace tasks—not just formulas and theory—and is customised for the organization’s industry, departments, employee skill levels and daily Excel challenges.
              </p>
              <div className="credential-grid">
                <div>
                  <strong>1,000+ Trained Professionals</strong>
                  <span>Improving Accuracy, Efficiency & Confidence</span>
                </div>
                <div>
                  <strong>Management & Engineering Graduate</strong>
                  <span>University of Moratuwa</span>
                </div>
                <div><strong>Managerial Experience</strong>
                  <span>Business Analysis & Corporate Strategy</span>
                </div>
                <div>
                  <strong>300+ Global Projects</strong>
                  <span>USA, UK, Canada, Australia & Middle East</span>
                </div>

              </div>
              <details className="background-details">
                <summary>View full professional background</summary>
                <div className="background-columns ">
                  <ul>
                    <li>Built a community of more than 73,000 learners and professionals through the Mr Excel Sri Lanka TikTok platform.</li>
                    <li>Trained more than 1,000 employees and professionals to improve accuracy, reduce manual work and become more confident with business data.</li>
                    <li>Earned Top Rated global status by delivering professional Excel solutions to international clients.</li>
                    <li>Completed more than 300 Excel-related projects for clients in the USA, UK, Canada and Australia.</li>
                    <li>Training coverage includes Basic Excel, Advanced Excel, Power Query, PivotTables, dashboards, AI tools, VBA, macros and automation.</li>
                  </ul>
                  <ul>
                    <li>Professional experience with Nestlé, John Keells Holdings, MAS and Hirdaramani across business analysis, data analysis, reporting and performance management.</li>
                    <li>More than 10 years of business-analysis experience supporting management reporting, process improvement and business transformation.</li>
                    <li>Industry exposure across Supply Chain, Finance, Consumer Goods, Inventory, Apparel, FMCG, Data Management, Business Reporting and Operations.</li>
                    <li>Specialises in converting repetitive Excel processes into efficient, standardised and automated workflows.</li>
                    <li>Director of Hellen Global (Pvt) Ltd, a software development company delivering practical digital solutions.</li>
                  </ul>
                </div>
              </details>
            </div>
          </div>
        </div>
      </section>

      <section className="outcomes-section">
        <div className="container outcomes-layout">
          <div className="outcomes-copy">
            <span className="eyebrow light-eyebrow">Why organizations choose my training</span>
            <h2>Designed to create Measurable Workplace Value</h2>
            <p>Employees learn how to apply Excel to their actual responsibilities, reports, datasets and operational challenges.</p>
          </div>
          <div className="outcome-list">
            <span>Reduce repetitive manual work</span>
            <span>Improve Reporting Accuracy</span>
            <span>Shorten report-preparation time</span>
            <span>Standardise Excel processes</span>
            <span>Strengthen analytical capability</span>
            <span>Build Future-ready Excel and AI skills</span>
          </div>
        </div>
      </section>

      <section className="home-section services-section services-feature-section">
        <div className="container">
          <div className="section-heading section-heading-centered">
            <span className="eyebrow">Functional Excellence</span>
            <h2>Popular Excel Programs Built for Every Department.</h2>
            <p>Facing bottlenecks or efficiency gaps in a specific department? Our department-focused Excel programs are built around your operational goals to improve productivity, strengthen decision-making, reduce inefficiencies, and deliver measurable impact on business performance and P&L.</p>
          </div>
          <div className="service-feature-grid">
            {departmentsData.map((dept) => (
              <article key={dept.id} className="service-feature-card">
                <div className={`service-feature-visual ${dept.visualClass} ${dept.coverImage ? 'visual-cover' : ''}`}>
                  <img
                    alt={`Illustration of ${dept.title}`}
                    loading="lazy"
                    src={dept.img}
                  />
                </div>
                <div className="service-feature-copy">
                  <span className="service-feature-kicker">{dept.tag}</span>
                  <h3>{dept.title}</h3>
                  <p>{dept.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="home-section faq-section">
        <div className="container faq-layout">
          <div className="section-heading">
            <span className="eyebrow">Frequently asked questions</span>
            <h2>Planning your Excel training</h2>
            <p>Quick answers to the questions organizations usually ask before arranging a session.</p>
          </div>
          <div className="faq">
            {faqItems.map((item, index) => {
              const isOpen = openFaq === index;
              return (
                <article key={index} className={`faq-item ${isOpen ? 'open' : ''}`}>
                  <button
                    aria-expanded={isOpen}
                    className="faq-question"
                    type="button"
                    onClick={() => setOpenFaq(isOpen ? -1 : index)}
                  >
                    {item.q}
                  </button>
                  <div className="faq-answer">
                    <p>{item.a}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="final-cta">
        <div className="container final-cta-inner">
          <div>
            <span className="eyebrow light-eyebrow">Start with your requirement</span>
            <h2>Let’s build practical Excel capability in your team</h2>
            <p>
              Tell me about your organization, participants and current Excel challenges. I will recommend a program designed to create workplace value.
            </p>
          </div>
          <a
            className="btn btn-light"
            href="#training-inquiry"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('training-inquiry')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Book Your Training
          </a>
        </div>
      </section>

      {videoModalOpen && (
        <div className="modal open" onClick={() => setVideoModalOpen(false)}>
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              type="button"
              onClick={() => setVideoModalOpen(false)}
            >
              &times;
            </button>
            <div className="modal-frame">
              <video
                src={introVideo}
                controls
                autoPlay
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </div>
          </div>
        </div>
      )}
    </main>
  );
}
